export default {
  slug: "code-with-me",
  code: "CWM",
  label: "Code With Me",
  krakenDir: "CodeWithMe",
  logoFamily: "jb",
};
